module.exports = __webpack_public_path__ + "static/puntos-855d1b77e48f87e5bea7b4a244a684d6.png";